import React, { Component } from 'react';
import StyleSheet from 'stilr';

const styles = StyleSheet.create({
  container: {
    background: '#fff',
    border: '1px solid lightgrey',
    padding: '1em'
  }
});

export default class Paper extends Component {
  render() {
    return <div className={styles.container}>{this.props.children}</div>;
  }
}
